module.exports = __webpack_public_path__ + "img/icono-general-light.7ea77d78.png";